import React, { ReactNode } from 'react'

import { useTheme } from '@mui/material'

import { IGNORE_ON_ALL_EXPORT } from 'components_new/organisms/dialogs/ExportDialog'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

import { TCustomization } from 'types/GlobalCustomization'
import { WidgetType } from 'types/GlobalWidget'

interface WidgetBaseProps {
  children: ReactNode
  customization?: TCustomization | null
  disableGutter?: boolean
  editMode: boolean
  plain: boolean
  scaleFactor: number
  title?: string
  widgetType: WidgetType
}

const WidgetBase = (props: WidgetBaseProps) => {
  const {
    children,
    customization,
    disableGutter,
    editMode,
    plain,
    scaleFactor,
    title,
    widgetType
  } = props

  const theme = useTheme()

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          width: '100%',
          p: disableGutter ? undefined : 1 * scaleFactor,
          // toggle widget menu
          '& .widget-menu': {
            display: editMode ? 'block' : 'none'
          },
          '&:hover': {
            '& .widget-menu': {
              display: 'block'
            },
            '& .widget-paper': {
              borderColor: editMode ? theme.palette.action.focus : undefined
            }
          },
          '& .widget-resize-icon': {
            display: editMode ? 'block' : 'none'
          }
        }}
      >
        <Box
          className="widget-paper"
          component="section"
          aria-label={title || undefined}
          sx={{
            bgcolor:
              widgetType === WidgetType.COMMENT
                ? 'rgba(0,0,0, 0.1)'
                : customization?.background_colors?.paper
                  ? customization?.background_colors?.paper
                  : 'background.paper',
            ...(!plain
              ? { border: '1px solid', borderColor: 'divider', borderRadius: 1 }
              : null),
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            position: 'relative'
          }}
        >
          {children}
          {widgetType === WidgetType.COMMENT ? (
            <Box
              id={IGNORE_ON_ALL_EXPORT}
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Text color="text.secondary" variant="caption" align="center">
                (Reserverad till externa kommentarer)
              </Text>
            </Box>
          ) : null}
        </Box>
        <Box
          className="widget-resize-icon"
          sx={{
            display: 'none',
            position: 'absolute',
            bottom: 12,
            right: 12,
            zIndex: 2
          }}
        >
          <Icon
            name="ArrowForwardIos"
            color="disabled"
            sx={{
              zIndex: 2,
              transform: 'rotate(45deg)',
              fontSize: 24 * scaleFactor
            }}
          />
        </Box>
      </Box>
    </>
  )
}

export default WidgetBase
